import * as React from 'react';

import * as styles from './MapWrapper.css';

export const MapWrapper: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles['wrapper']}>{children}</div>;
};
